import { mapState, mapMutations } from 'vuex';
import env from 'md-base-tools/env';
import domain from '@/service/domain';
import redirect from '@/service/redirect';
import { getMyleagueInviteCode } from '@api/index';
import { mdToast, GoBack, wxMinaShare } from '@/utils/tools';
import ShareBox from '@@/common/ShareBox.vue';

// 分享文案与链接（TCG 活动页）
const share_des = '星之烬';
const share_1x1 = 'https://p6.moimg.net/md/activity/tcg/app_activity_tcg_01.jpg?x-oss-process=image/resize,w_350,h_350,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1';
const share_5x4 = 'https://p6.moimg.net/md/activity/tcg/app_activity_tcg_01.jpg?x-oss-process=image/resize,w_600,h_480,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1';
const share_page_url = `${domain.wap}/mdactivity/fastsell/tcg`;
const shareInfo = {
  active_title: '',
  img: share_1x1,
  mina_app_name: 'gh_7210ac3f1f08',
  mina_share_img: share_5x4,
  mina_share_path: 'pages/webviewPages/content/content?url=' + share_page_url,
  msg_des: share_des,
  qq_des: '',
  qq_share_url: share_page_url,
  qq_title: share_des,
  qr_img: share_1x1,
  qzone_share_url: share_page_url,
  share_url: share_page_url,
  sharelink_url: share_page_url,
  small_code: '',
  weibo_des: share_des + share_page_url,
  weibo_share_url: share_page_url,
  weibo_title: '',
  weixin_share_url: share_page_url,
  wxTimeline_share_url: share_page_url,
  wx_des: '',
  wx_title: share_des
};
export default {
  components: {
    ShareBox
  },
  data() {
    return {
      env,
      is_ip: false,
      // 是否 IP 页（IP 页不展示返回）
      statusBarH: 10,
      // APP 状态栏高度
      isFix: 0,
      // 吸顶态，用于返回/分享底色
      pageImages: ['https://p6.moimg.net/md/activity/tcg/app_activity_tcg_01.jpg', 'https://p6.moimg.net/md/activity/tcg/app_activity_tcg_02.png', 'https://p6.moimg.net/md/activity/tcg/app_activity_tcg_0333.jpg', 'https://p6.moimg.net/md/activity/tcg/app_activity_tcg_04.png', 'https://p6.moimg.net/md/activity/tcg/app_activity_tcg_05.jpg'],
      // 页面图片
      pageVideos: ['', 'https://f1.moimg.net/astralash/file/wzb.mp4', '', 'https://f1.moimg.net/astralash/file/jx.mp4', ''],
      // 页面视频，index=1 为首个，index=3 为第二个
      invite_code: '',
      // 邀请码
      secondVideoPlaying: false,
      // 第二个视频是否已开始播放
      loading: false // 防重复请求
    };
  },
  computed: {
    ...mapState({
      userId: state => state.user.userId
    })
  },
  mounted() {
    document.title = '星之烬';
    this.is_ip = this.$route.query.is_ip == 1;
    // APP 内：状态栏样式 + 状态栏高度（与 category_month 一致）
    if (env.isModianIos() || env.isModianAndroid()) {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: 'webNavColor',
        functionParams: {
          statusBarColorIsWhite: '1'
        }
      });
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: 'onGetDeviceInfo',
        functionParams: {},
        callBack: e => {
          this.statusBarH = e.data.statusBarH;
        }
      });
    }
    // 微信小程序分享
    wxMinaShare({
      title: share_des,
      imageUrl: share_5x4,
      url: share_page_url
    });
    // 兜底触发首个视频静音自动播放（部分 WebView 需主动调用）
    this.$nextTick(() => {
      this.tryPlayFirstVideo();
      this.showFirstVideoFirstFrame();
      this.showSecondVideoFirstFrame();
    });
  },
  methods: {
    ...mapMutations(['changeShareStatus', 'currentShareUpdate']),
    /**
     * 吸顶状态变化：用于返回/分享按钮底色
     */
    handleStickyAction(isFixed) {
      this.isFix = isFixed ? 1 : 0;
    },
    /**
     * APP 内嵌页返回上一页
     */
    handleGoBack() {
      GoBack();
    },
    /**
     * 分享：APP 调原生分享，H5 走 ShareBox
     */
    handleShareAction() {
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: 'openShareTool',
          functionParams: JSON.parse(JSON.stringify(shareInfo))
        });
      } else {
        this.currentShareUpdate({
          obj: 'share_info',
          value: shareInfo
        });
        this.changeShareStatus({
          obj: 'showShare'
        });
      }
    },
    /**
     * 统一取 v-for 内 video ref（Vue3 可能为数组）
     */
    getVideoEl(refName) {
      const video = this.$refs[refName];
      return Array.isArray(video) ? video[0] : video;
    },
    /**
     * 强制渲染视频首帧
     * 部分手机 WebView 在未播放时黑屏，需 seek 到极短时间触发画面
     */
    showVideoFirstFrame(refName) {
      const el = this.getVideoEl(refName);
      if (!el) return;
      // 已在播放中则不干预
      if (!el.paused && el.currentTime > 0.1) return;
      try {
        el.currentTime = 0.1;
      } catch (e) {
        // ignore
      }
    },
    /**
     * 第一个视频首帧（自动播放失败时兜底，避免黑屏）
     */
    showFirstVideoFirstFrame() {
      this.showVideoFirstFrame('firstVideo');
    },
    /**
     * 尝试播放第一个视频（静音循环）
     * 部分 APP WebView 对 autoplay 支持不稳定，mounted 后主动 play；
     * 播放失败时回退展示首帧，用户仍可通过 controls 手动播放
     */
    tryPlayFirstVideo() {
      const el = this.getVideoEl('firstVideo');
      if (!el) return;
      el.muted = true;
      const fallbackFirstFrame = () => {
        this.showFirstVideoFirstFrame();
      };
      const playPromise = el.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(fallbackFirstFrame);
      }
      // 兜底：部分安卓 WebView play 不返回 Promise，延时检测是否仍在暂停
      setTimeout(() => {
        if (el.paused && el.readyState >= 2) {
          fallbackFirstFrame();
        }
      }, 300);
    },
    /**
     * 暂停第一个视频
     */
    pauseFirstVideo() {
      const el = this.getVideoEl('firstVideo');
      if (el && !el.paused) {
        el.pause();
      }
    },
    /**
     * 第二个视频首帧
     */
    showSecondVideoFirstFrame() {
      this.showVideoFirstFrame('secondVideo');
    },
    /**
     * 第二个视频开始播放：隐藏遮罩，并暂停第一个视频
     */
    onSecondVideoPlay() {
      this.secondVideoPlaying = true;
      this.pauseFirstVideo();
    },
    /**
     * 点击播放第二个视频
     * 先暂停第一个，再 play，用户可通过 controls 进入全屏
     */
    playSecondVideo() {
      const el = this.getVideoEl('secondVideo');
      if (!el) return;
      this.pauseFirstVideo();
      el.play().then(() => {
        this.secondVideoPlaying = true;
      }).catch(() => {
        mdToast('视频播放失败');
      });
    },
    /**
     * 点击底部/热区：校验登录 → 拉邀请码 → openTCG 跳转
     * 已有 invite_code 时直接跳转，避免重复请求
     */
    async getInviteCode() {
      if (this.loading) return;
      if (this.invite_code) {
        this.openTCG();
        return;
      }
      // 未登录跳转登录（与 miner_rank 一致）
      if (!this.userId) {
        return redirect.to('login');
      }
      this.loading = true;
      try {
        const {
          status,
          data,
          message
        } = await getMyleagueInviteCode();
        if (status === 0 && data && data.invite_code) {
          this.invite_code = data.invite_code;
          this.openTCG();
        } else {
          mdToast(message || '获取邀请码失败');
        }
      } catch (e) {
        mdToast('获取邀请码失败');
      } finally {
        this.loading = false;
      }
    },
    /**
     * 通过微信 URL Scheme 跳转 TCG 小程序，query 为邀请码
     */
    openTCG() {
      const accessCode = encodeURIComponent('access_code=' + this.invite_code);
      location.href = 'weixin://dl/business/?appid=wxb3a58805c0e41cc6&query=' + accessCode; // + '&env_version=develop' 测试环境
    }
  }
};